import { createFileRoute, redirect } from '@tanstack/react-router'
import { orderContractDocumentSearchSchema, RentalContractPage } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/contract/$rentalId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.rentalId)) || Number(params.rentalId) < 1) {
      throw redirect({ to: '/orders/rentals', search: { current: 1, pageSize: 20 } })
    }
  },
  validateSearch: orderContractDocumentSearchSchema,
  component: Page
})
function Page() {
  const { currentSession } = Route.useRouteContext()
  return (
    <RentalContractPage
      rentalOrderId={Number(Route.useParams().rentalId)}
      documentId={Route.useSearch().documentId}
      canManage={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some(
          (permission) => permission.startsWith('order.rental.') && !permission.endsWith('.read')
        )
      }
      canSubmit={currentSession.isSuperAdmin || currentSession.permissions.includes('contract.document.create')}
    />
  )
}
